import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from 'styled-components';
import { ChatbotMessageActions } from './ChatbotMessageActions.js';
import { motion } from 'framer-motion';
import { useState, useRef } from 'react';
import { useDomContentRect } from '@fabric-app/hooks/useDomContentRect';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { ChatbotMessageRole } from '@fabric/woody-client';

const COLLAPSED_HEIGHT = 120;
const ChatbotMessageSummaryBox = ({ summary, style }) => {
  const [isOpen, setIsOpen] = useState(false);
  const innerRef = useRef(null);
  const [innerRect] = useDomContentRect(innerRef);
  const innerHeight = innerRect?.height ?? 0;
  const minHeight = Math.min(innerHeight || COLLAPSED_HEIGHT, COLLAPSED_HEIGHT);
  return /* @__PURE__ */ jsxs(Box, {
    style,
    initial: {
      height: minHeight,
      minHeight
    },
    animate: {
      height: isOpen ? innerHeight : minHeight,
      minHeight
    },
    onClick: COLLAPSED_HEIGHT < innerHeight ? () => setIsOpen((v) => !v) : void 0,
    children: [
      /* @__PURE__ */ jsx(ShadowOverlay, {
        isCollapsed: innerHeight > COLLAPSED_HEIGHT && !isOpen
      }),
      /* @__PURE__ */ jsxs(Inner, {
        ref: innerRef,
        children: [
          /* @__PURE__ */ jsx(Title, {
            children: "AI Summary"
          }),
          /* @__PURE__ */ jsx(Text, {
            children: summary
          }),
          /* @__PURE__ */ jsx(ChatbotMessageActions, {
            message: {
              content: summary,
              id: "",
              role: ChatbotMessageRole.assistant
            }
          })
        ]
      })
    ]
  });
};
const Inner = styled.div.withConfig({
  displayName: "ChatbotMessageSummaryBox__Inner",
  componentId: "sc-77fd00bc-0"
})([
  `display:flex;flex-direction:column;gap:0.75rem;padding:0.75rem;`
]);
const Box = styled(motion.div).withConfig({
  displayName: "ChatbotMessageSummaryBox__Box",
  componentId: "sc-77fd00bc-1"
})([
  `border-radius:0.75rem;border:1.2px dashed `,
  `;width:100%;overflow:hidden;position:relative;cursor:pointer;`
], cssVar["color-text-primary"]);
const ShadowOverlay = styled.div.withConfig({
  displayName: "ChatbotMessageSummaryBox__ShadowOverlay",
  componentId: "sc-77fd00bc-2"
})([
  `position:absolute;height:50px;left:0;right:0;bottom:0;background:linear-gradient(180deg,rgba(47,47,47,0) 0%,`,
  ` 100%);z-index:1;opacity:0;pointer-events:none;transition:opacity 0.2s ease-in-out;`,
  ``
], cssVar["color-bg-assistant"], ({ isCollapsed }) => isCollapsed && `
    opacity: 1;
  `);
const Title = styled.div.withConfig({
  displayName: "ChatbotMessageSummaryBox__Title",
  componentId: "sc-77fd00bc-3"
})([
  `font-size:14px;font-weight:600;line-height:1.25;color:`,
  `;`
], cssVar["color-text-primary"]);
const Text = styled.div.withConfig({
  displayName: "ChatbotMessageSummaryBox__Text",
  componentId: "sc-77fd00bc-4"
})([
  `font-size:14px;font-weight:400;line-height:1.375rem;color:`,
  `;`
], cssVar["color-text-primary"]);

export { ChatbotMessageSummaryBox };
//# sourceMappingURL=ChatbotMessageSummaryBox.js.map
